var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshError16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83994 2.5C4.89079 2.5 2.50004 4.89075 2.50004 7.8399C2.50004 10.789 4.89079 13.1798 7.83994 13.1798V13.1799C10.7891 13.1799 13.1798 10.7892 13.1798 7.84002C13.1798 7.42581 13.5156 7.09002 13.9298 7.09002C14.344 7.09002 14.6798 7.42581 14.6798 7.84002C14.6798 11.6176 11.6175 14.6799 7.8399 14.6799C4.06233 14.6799 1 11.6176 1 7.84002L1.00004 7.83203C1.00429 4.05807 4.06499 1 7.83994 1C9.1446 1 10.7166 1.14865 12.2833 2.74758L11.2118 3.79737C10.0516 2.61321 8.96275 2.5 7.83994 2.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 3.67627L12.0492 3.67627L12.0492 1.3927",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshError16);
export default __webpack_public_path__ + "static/media/refresh_error_16.36db6152f840c7920fc4072750847b03.svg";
export { ForwardRef as ReactComponent };